import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
import possibilityImage from '../../assets/place3.jpeg';
import slider1 from '../../assets/place1.jpg';
import slider2 from '../../assets/place4.jpeg';

export default function InfoModal({ text }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button className="nextButton" onClick={handleShow}>
        <FontAwesomeIcon icon={faMapMarker} />
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>{text}</Modal.Title>
          <Button variant="danger" onClick={handleClose}>
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
            <div>
              <img src={possibilityImage} />
            </div>
            <div>
              <img src={slider1} />
            </div>
            <div>
              <img src={slider2} />
            </div>
          </Carousel>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Interested
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Going
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Want a team
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            T-List
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Details
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
